import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d49cbb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "player-preview" }
const _hoisted_2 = ["src", "alt"]


import CircleButton from '@/components/Buttons/CircleButton.vue'
import { IPlaylistItem } from '@/api'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewPlayer',
  props: {
    media: {},
    overlay: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "player-preview__background",
      src: props.media?.thumbnail_url,
      alt: props.media?.title
    }, null, 8, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(props.overlay ? 'player-preview__overlay player-preview__overlay-black':'player-preview__overlay')
    }, [
      _createVNode(CircleButton, {
        class: "btn-player__action play",
        bg: "none",
        name: "play",
        iconWidth: 47,
        iconHeight: 47,
        "view-box": "0 0 28.58 39.49"
      })
    ], 2)
  ]))
}
}

})